import { render } from "./EvaluationView.vue?vue&type=template&id=27dd2135"
import script from "./EvaluationView.vue?vue&type=script&lang=js"
export * from "./EvaluationView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__